var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal new-series-modal",
      attrs: {
        id: "new-series-modal",
        "ok-disabled": _vm.newSeriesDisabled,
        "ok-busy": _vm.busy
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.create()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "new-series-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.new_series.title")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "new-series-modal__form" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600",
              attrs: { for: "subject-select" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("publishers.modal.new_series.subject")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected.subjectId,
                  expression: "selected.subjectId"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "subject-select" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.selected,
                    "subjectId",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { disabled: "", value: "" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("publishers.modal.new_series.subject_placeholder")
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.subjectIds.filter(function(id) {
                  return id !== "0" && id !== "9999"
                }),
                function(sjId) {
                  return _c(
                    "option",
                    { key: sjId, domProps: { value: sjId } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getTranslatedName(_vm.subjectMap[sjId])) +
                          "\n        "
                      )
                    ]
                  )
                }
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600",
              attrs: { for: "grade-select" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("publishers.modal.new_series.grade")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected.gradeId,
                  expression: "selected.gradeId"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "grade-select" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.selected,
                    "gradeId",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { disabled: "", value: "" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("publishers.modal.new_series.grade_placeholder")
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.gradeIds.filter(function(id) {
                  return id !== "0" && id !== "9999"
                }),
                function(gId) {
                  return _c("option", { key: gId, domProps: { value: gId } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.getTranslatedName(_vm.gradeMap[gId])) +
                        "\n        "
                    )
                  ])
                }
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600",
              attrs: { for: "series-title-input" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("publishers.modal.new_series.name")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.seriesTitle,
                expression: "seriesTitle"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "series-title-input",
              placeholder: _vm.$t(
                "publishers.modal.new_series.name_placeholder"
              )
            },
            domProps: { value: _vm.seriesTitle },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.seriesTitle = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showChapterSelect,
                expression: "showChapterSelect"
              }
            ],
            staticClass: "form-group"
          },
          [
            _c(
              "label",
              {
                staticClass:
                  "typography--body-3 typography--color-secondary typography--font-weight-600",
                attrs: { for: "chapter-count-select" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("publishers.modal.new_series.unit")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selected.chapterCount,
                    expression: "selected.chapterCount"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "chapter-count-select" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.selected,
                      "chapterCount",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { disabled: "", value: "" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("publishers.modal.new_series.unit_placeholder")
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _vm._l(20, function(n) {
                  return _c("option", { key: n, domProps: { value: n } }, [
                    _vm._v("\n          " + _vm._s(n) + "\n        ")
                  ])
                })
              ],
              2
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a979744", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a979744","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/NewSeriesModal.vue
// module id = l8k1
// module chunks = 1